module.exports = __webpack_public_path__ + "img/BRANDING01_OG.97a35b74.jpg";